// authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, verifyOtpApi } from '../../utils/Constants';

export const verifyOtp = createAsyncThunk(
  "verifyOtp",
  async (payload, { rejectWithValue }) => {
    try {
    const config = {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
        },
    };
    const response = await axios.put(`${BASE_URL}${verifyOtpApi}`, payload, config);
    return response.data;
    } catch (error) {
      localStorage.removeItem("Token");
      localStorage.removeItem("userId");
      localStorage.removeItem("type");
      return rejectWithValue(
        error?.response?.data?.message || "Failed to login."
      );
    }
  }
);

const otpSlice = createSlice({
    name: 'otp',
    initialState: {
        data: null,
        isAuthenticated: false,
        loading: false,
        error: null,
    },
    reducers: {
        clearOtpData: (state) => {
            state.data = null;
            state.error = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(verifyOtp.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(verifyOtp.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(verifyOtp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearOtpData } = otpSlice.actions;
export default otpSlice.reducer;
